import { parseIsins, parseELF, parseRA, } from '@/store/modules/record/helpers/parsing'

export default [
  {
    label: '(Primary) Legal Name',
    jsonPath: '$.entity.legalName.name',
    fieldId: 'LEIREC_LEGAL_NAME',
    type: 'STRING',
    inline: true,
    text: 'The legal name of the legal entity, as used in the entity\'s articles of incorporation, foundation documents or other fundamental legal forms; it should be the exact name used in the relevant business register or other official database. In jurisdictions with mutliple legal names, e.g. in different languages, the primary legal name.',
    tip: 'The Legal Name includes the name of the umbrella structure.',
  },
  {
    label: 'Other Names',
    type: 'STRING',
    isOtherNames: true,
    inline: true,
    text: 'An alternative name, or representation of a name, for the legal entity, excluding transliterations.',
    fieldId: 'LEIREC_OTHER_NAME',
    jsonPath: '$.entity.otherNames[*].name',
  },
  {
    label: 'Transliterated Names',
    type: 'STRING',
    isOtherNames: true,
    inline: true,
    text: 'An transliterated version of a name or representation of a name for the legal entity.',
    fieldId: 'LEIREC_TRANSLITERATED_OTHER_NAME',
    jsonPath: '$.entity.transliteratedOtherNames[*].name',
  },
  {
    label: 'Registered At',
    getValue: parseRA,
    type: 'RESOURCE',
    inline: true,
    fieldId: 'LEIREC_REGISTERED_AT',
    exchange: 'LEIREC_REGISTRATION_AUTHORITY_ID',
    alternativeInput: true,
    text: 'A code (from the official GLEIF Registration Authority List) for the registration authority.',
    jsonPath: '$.entity.registeredAt',
  },
  {
    label: 'Registered As',
    type: 'STRING',
    inline: true,
    text: 'An identifier for the legal entity in the registration authority.',
    fieldId: 'LEIREC_REGISTRATION_AUTHORITY_ENTITY_ID',
    jsonPath: '$.entity.registeredAs',
  },
  {
    label: 'Jurisdiction Of Formation',
    getValue: (jr) => jr.code ? jr.code : jr,
    type: 'RESOURCE',
    inline: true,
    fieldId: 'LEIREC_LEGAL_JURISDICTION',
    text: 'The jurisdiction of legal formation and registration of the entity (and on which the LegalForm data element is also dependent).',
    jsonPath: '$.entity.jurisdiction',
  },
  {
    label: 'General Category',
    type: 'ENUM',
    inline: true,
    fieldId: 'LEIREC_ENTITY_CATEGORY',
    allowUnset: true,
    text: 'A more specific category of legal entity within the broad definition given in ISO 17442, based on LEI-ROC policies.',
    jsonPath: '$.entity.category',
  },
  {
    label: 'Sub Category',
    type: 'ENUM',
    inline: true,
    fieldId: 'LEIREC_ENTITY_SUB_CATEGORY',
    allowUnset: true,
    text: 'A more specific category of legal entity within the broad definition given in ISO 17442, based on LEI-ROC policies.',
    jsonPath: '$.entity.subCategory',
  },
  {
    label: 'Entity Legal Form',
    type: 'RESOURCE',
    getValue: parseELF,
    exchange: 'LEIREC_ENTITY_LEGAL_FORM_CODE',
    fieldId: 'LEIREC_LEGAL_FORM',
    alternativeInput: true,
    inline: true,
    text: 'A current code for the entity\'s legal form, from the ISO / GLEIF ELF list.',
    jsonPath: '$.entity.legalForm',
  },
  {
    label: 'Associated Entity',
    type: 'STRING',
    text: 'Deprecated field',
    isDeprecated: true,
    fieldId: 'LEIREC_ASSOCIATED_ENTITY',
    exchange: 'LEIREC_ASSOCIATED_ENTITY_NAME',
    jsonPath: '$.entity.associatedEntity',
  },
  {
    label: 'Entity Status',
    type: 'ENUM',
    fieldId: 'LEIREC_ENTITY_STATUS',
    inline: true,
    text: 'The legal entity\'s operating and legal registration status.',
    isStatus: true,
    jsonPath: '$.entity.status',
  },
  {
    label: 'Expiration',
    isDeprecated: true,
    text: 'Deprecated field',
    jsonPath: '$.entity.expiration',
  },
  {
    label: 'Expiration Date',
    type: 'DATE',
    isDeprecated: true,
    fieldId: 'LEIREC_ENTITY_EXPIRATION_DATE',
    text: 'The date that the legal entity ceased to operate, whether due to dissolution, merger or acquisition.',
    jsonPath: '$.entity.expiration.date',
  },
  {
    label: 'Expiration Reason',
    type: 'ENUM',
    isDeprecated: true,
    fieldId: 'LEIREC_ENTITY_EXPIRATION_REASON',
    text: 'The type of reason why this legal entity ceased to operate.',
    jsonPath: '$.entity.expiration.reason',
  },
  {
    label: 'Entity created at',
    type: 'DATE',
    inline: true,
    fieldId: 'LEIREC_ENTITY_CREATION_DATE',
    text: 'The date that the legal entity was created.',
    jsonPath: '$.entity.creationDate',
  },
  {
    label: 'Replaced By',
    isEntity: true,
    inline: true,
    fieldId: 'LEIREC_SUCCESSOR_ENTITY',
    exchange: 'LEIREC_SUCCESSOR_ENTITY_NAME',
    text: 'One or more Legal Entities that continue or replace this LEI',
    jsonPath: '$.entity.successorEntity',
  },
  {
    type: 'STRING',
    label: 'Replaced By',
    autocompleteEntity: true,
    fieldId: 'LEIREC_SUCCESSOR_ENTITIES_LEI',
    isEntity: true,
    inline: true,
    text: 'One or more Legal Entities that continue or replace this LEI',
    jsonPath: '$.entity.successorEntities[*].lei',
  },
  {
    type: 'STRING',
    label: 'Replaced By',
    inline: true,
    fieldId: 'LEIREC_SUCCESSOR_ENTITIES_NAME',
    text: 'One or more Legal Entities that continue or replace this LEI',
    jsonPath: '$.entity.successorEntities[*].name',
  },
  {
    label: 'BIC Code',
    type: 'STRING',
    disabled: true,
    text: 'A Business Identifier Code (BIC) which is assigned to this legal entity.',
    tip: 'BIC Code is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    fieldId: 'LEIREC_BIC',
    jsonPath: '$.bic',
  },
  {
    label: 'ISIN Code',
    type: 'STRING',
    text: 'ISIN Code',
    disabled: true,
    fieldId: 'LEIREC_ISIN',
    getValue: parseIsins,
    tip: 'ISIN Code is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    jsonPath: '$.isin',
  },
  {
    label: 'S&P Global Company ID',
    type: 'STRING',
    disabled: true,
    text: 'The S&P Global Company ID that was mapped to this LEI record.',
    tip: 'The S&P Global Company ID is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    fieldId: 'LEIREC_SPGLOBAL',
    jsonPath: '$.spglobal',
  },
  {
    label: 'MIC Code',
    type: 'STRING',
    disabled: true,
    text: 'A Market Identifier Code (MIC) which is assigned to this legal entity.',
    tip: 'MIC Code is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    fieldId: 'LEIREC_MIC',
    jsonPath: '$.mic',
  },
  {
    label: 'OpenCorporates ID',
    type: 'STRING',
    disabled: true,
    text: 'An Open Corporate (OC) which is assigned to this legal entity.',
    tip: 'OC Code is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    fieldId: 'LEIREC_OCID',
    jsonPath: '$.ocid',
  },
  {
    label: 'QCC Code',
    type: 'STRING',
    disabled: true,
    text: 'An QCC which is assigned to this legal entity.',
    tip: 'QCC Code is currently not challengeable. In case of any questions, please refer these to info@gleif.org',
    fieldId: 'LEIREC_QCC',
    jsonPath: '$.qcc',
  },
]



// WEBPACK FOOTER //
// ./src/utils/challenge/entity-details.js